import { createAction, handleActions } from 'redux-actions';
import { put, takeEvery } from 'redux-saga/effects';
import produce from 'immer';

const SHOW = 'notification/SHOW';
const HIDE = 'notification/HIDE';
const REMOVE = 'notification/REMOVE';

export const showNotification = createAction(SHOW);
export const hideNotification = createAction(HIDE);
export const removeNotification = createAction(REMOVE);

function* showNotificationSaga({ payload }) {
    const type = `${SHOW}_SUCCESS`;
    yield put({ type, payload });
}

function* hideNotificationSaga({ payload }) {
    const type = `${HIDE}_SUCCESS`;
    yield put({ type, payload });
}

function* removeNotificationSaga({ payload }) {
    const type = `${REMOVE}_SUCCESS`;
    yield put({ type, payload });
}

export function* notificationSagas() {
    yield takeEvery(SHOW, showNotificationSaga);
    yield takeEvery(HIDE, hideNotificationSaga);
    yield takeEvery(REMOVE, removeNotificationSaga);
}

const initialState = {
    notifications: [],
};

const module = handleActions(
    {
        [`${SHOW}_SUCCESS`]: (state, { payload }) =>
            produce(state, (draft) => {
                const key = new Date().getTime() + Math.random();
                draft.notifications.push({ key, ...payload });
            }),
        [`${HIDE}_SUCCESS`]: (state, { payload: key }) => ({
            notifications: state.notifications.map((notification) =>
                notification.key === key ? { ...notification, dismissed: true } : { ...notification }
            ),
        }),
        [`${REMOVE}_SUCCESS`]: (state, { payload: key }) => ({
            notifications: state.notifications.filter((notification) => (key.length ? notification.key !== key : false)),
        }),
    },
    initialState
);

export default module;
